module.exports = __webpack_public_path__ + "static/media/Banner.6f7f69f9.png";